import styled from 'styled-components';

const StyledInvoiceFilePreviewWithIcon = styled.span`
  align-items: center;
  display: inline-flex;
  justify-content: center;
`;

export {
  StyledInvoiceFilePreviewWithIcon
}
